import type { BlogPost } from '@types'

import { seoUrlPathEncode } from '@lib/helpers/client'

// A post with no date renders "Date unavailable", never today's date: matches [post]/page.tsx. [S20-1320]
export function formatPostDate(timestamp?: number): string {
  return timestamp
    ? new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(new Date(timestamp))
    : 'Date unavailable'
}

export function postUrl(post: Pick<BlogPost, 'id' | 'title'>): string {
  return `/blogs/${seoUrlPathEncode(post.title, 'blog')}-${post.id}`
}
